export default __webpack_public_path__ + "static/why-ml-9-8c6855f1a5e401c180e5af27ac02d7d4.webp";